// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"148":"d14c40e7","324":"e0152afe","823":"179ed65e"}[chunkId] + ".js";
};